
import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { DocumentIcon, JpgIcon, PdfIcon, PngIcon, VerticalDotsIcon } from "../../../utils/icons";
import { Dropdown, DropdownButton } from "react-bootstrap";
import { DownAngleV2 } from "../../SocialFeedsV2/styles";
import CommonListView from "../../common/CommonListView/CommonListView";


const DocCell = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const DocIcon = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 6px;
  ${'' /* background: #eef2ff; */}
  display: flex;
  align-items: center;
  justify-content: center;

  color: #184A61;
  font-family: Lato;
  font-size: 14px;
  font-weight: 400;
`;

const DocName = styled.span`
  color: #184A61;
  font-family: Lato;
  font-size: 18px;
  font-weight: 700;
  margin-right:20px;
`;

const TextCell = styled.div`
  color: #184A61;
  font-family: Lato;
  font-size: 16px;
`;

const MenuWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

/* ---------------- Headers ---------------- */

const headers = [
  { key: "doc", label: "Doc Name" },
  { key: "downloads", label: "Downloads" },
  { key: "uploaded_by", label: "Uploaded By" },
  { key: "last_updated", label: "Last Updated" },
  { key: "menu", label: "" },
];

/* ---------------- Component ---------------- */

const DocumentsListView = ({
  documents = [],
  onEdit,
  onDownload,
  onDelete,
}) => {

  const getFileIcon = (ext = "") => {
    const extension = ext.toLowerCase();

    switch (extension) {
    case "pdf":
      return <PdfIcon/>;
    case "jpeg":
      return <JpgIcon/>;
    case "png":
      return <PngIcon/>;
    default:
      return <DocumentIcon/>; // fallback
    }
  };

  const renderCell = (key, doc) => {

    if (key === "doc") {
      return (
        <DocCell>
          <DocIcon>{getFileIcon(doc?.extension)}</DocIcon>
          <DocName>{doc?.title}</DocName>
        </DocCell>
      );
    }

    if (key === "downloads") {
      return <TextCell>{doc.downloads}</TextCell>;
    }

    if (key === "uploaded_by") {
      return <TextCell>{doc?.uploaded_by}</TextCell>;
    }

    if (key === "last_updated") {
      return <TextCell>{doc?.last_updated}</TextCell>;
    }

    if (key === "menu") {
      return (
        <MenuWrapper>
          <DownAngleV2 feed padding="0 16px" marginL="-140px">
            <DropdownButton id="docMenu" title={<VerticalDotsIcon />}>
              <Dropdown.Item onClick={() => onEdit(doc)}>
                Edit
              </Dropdown.Item>

              <Dropdown.Item onClick={() => onDownload(doc)}>
                Download
              </Dropdown.Item>

              <Dropdown.Item onClick={() => onDelete(doc)}>
                Delete
              </Dropdown.Item>
            </DropdownButton>
          </DownAngleV2>
        </MenuWrapper>
      );
    }

    return null;
  };

  return (
    <CommonListView
      headers={headers}
      data={documents}
      grid="2fr 1fr 1.5fr 1.5fr 40px"
      renderCell={renderCell}
    />
  );
};

/* ---------------- PropTypes ---------------- */

DocumentsListView.propTypes = {
  documents: PropTypes.array.isRequired,
  onEdit: PropTypes.func,
  onDownload: PropTypes.func,
  onDelete: PropTypes.func,
};

export default DocumentsListView;
